<div *ngIf="!isLoading" class="course-card-container">

  

  <mat-card class="course-card course-card--filters">
    <mat-card-header>
      <mat-card-title translate>{{ getSearchString() }}</mat-card-title>
    </mat-card-header>
    <div *ngIf="!courseView && !isCourseDetail" [formGroup]="search" style=" width:100%; max-width: 1024px;" >
      <div class="inputSearchStyle" >
        <mat-form-field appearance="outline">
          <mat-label translate>COMMONS.SEARCH</mat-label>
          <mat-icon matPrefix [inline]="true">search</mat-icon>
          <input formControlName="searchString" matInput placeholder="{{ 'COMMONS.SEARCH' | translate }}"  #searchText />
          <mat-icon matSuffix [inline]="true" class="pointer" (click)="clearSearch()">highlight_off</mat-icon>
        </mat-form-field>
      </div>
    </div>
  </mat-card>

  <mat-card class="course-card course-card--courses">
    <mat-card-header>
      <div style="display:flex;justify-content: space-between; width:100%">
        <div><mat-card-title translate>{{ getTitleString() }} </mat-card-title></div>
        <div style="margin-top: 0.1rem;"><h6>{{courseProgramsTable.data.length}} <mat-label translate>COMMONS.RESULTS</mat-label></h6></div>
      </div>
    </mat-card-header>
    <div class="table-style">
      <div style="margin-top: 2rem;">
        <span translate style="font-size: 1rem;">COMMONS.FILTER_BY</span>:
        <div class="filters-container" style="width: 100%; margin-top: 0.6rem;" [formGroup]="search">
          <mat-form-field appearance="outline">
            <mat-label><span translate>COMMONS.COURSEPRODUCT</span>*</mat-label>
            <mat-select [disabled]="productLearningAreas.length == 0" formControlName="courseProduct">
              <mat-option value=""><span translate>COMMONS.SELECTALL</span></mat-option>
              <mat-option *ngFor="let product of productLearningAreas" [value]="product.ProductCode">{{product.Description}}</mat-option>
            </mat-select>
          </mat-form-field>
    
          <mat-form-field appearance="outline">
            <mat-label *ngIf="!trainingPlans" translate>COMMONS.COURSEAREA</mat-label>
            <mat-label *ngIf="trainingPlans" translate>COMMONS.COURSEPLANAREA</mat-label>
            <mat-select [disabled]="areasString.length == 0" formControlName="courseArea">
              <mat-option value=""><span translate>COMMONS.SELECTALL</span></mat-option>
              <mat-option *ngFor="let area of areasString" [value]="area.Code">{{area.Description}}</mat-option>
            </mat-select>
          </mat-form-field>
          
          <mat-form-field appearance="outline">
            <mat-label translate>COMMONS.COURSELANGUAGE</mat-label>
            <mat-select formControlName="courseLanguage">
              <mat-option value=""><span translate>COMMONS.SELECTALL</span></mat-option>
              <mat-option *ngFor="let language of getCourseLanguages()" [value]="getLanguageKey(language)"><span translate>{{language}}</span></mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      

      <table *ngIf="courseProgramsTable.data.length > 0" mat-table [dataSource]="courseProgramsTable" multiTemplateDataRows matSort >
        <ng-container matColumnDef="product">
          <td mat-cell *matCellDef="let element">
            <div style="display:flex;flex-direction:row; margin-top: 1rem; margin-bottom: 1rem;">
              <div *ngIf="!courseImageLoading.includes(element.CourseName)">
                <img [src]="element.CourseImage" style="max-width: 280px" >
              </div>
              <div *ngIf="courseImageLoading.includes(element.CourseName)">
                <mat-spinner></mat-spinner>
              </div>
              <div style="display:flex;flex-direction:column; margin-right: 2rem; margin-left: 2rem;flex-grow: 4;  row-gap: 0.2rem;column-gap: 0.5rem;">
                <div><button mat-icon-button (click)="showCourseDetail(element)"><h3>{{element.Description}}</h3></button></div>
                <div><p>{{element.Program}}</p></div>
                <div><mat-label class="text-bold" translate>COMMONS.PRODUCT</mat-label>:<span [class]="['product-layout', 'bg-' + element.ProductCode.toLowerCase().replace('.', '') ]">{{this.universityService.getProductDescription(element.ProductCode)}}</span></div>
                <div>
                  <mat-label *ngIf="!trainingPlans" class="text-bold" translate>COMMONS.COURSEAREA</mat-label>
                  <mat-label *ngIf="trainingPlans" class="text-bold" translate>COMMONS.COURSEPLANAREA</mat-label>
                  : {{ getAreaString(element.LearningArea) }} 
                </div>
                <div><mat-label class="text-bold" translate>COMMONS.COURSELANGUAGE</mat-label>: {{element.CourseLanguage}}</div>
                <div><mat-label class="text-bold" translate>COMMONS.COURSECOUNTRIES</mat-label>: <span translate>{{element.Countries ? element.Countries : 'COMMONS.ALL_COUNTRIES'}}</span></div>
              </div>
              <div><button mat-icon-button (click)="showCourseDetail(element)"><h3><mat-icon>arrow_forward</mat-icon></h3></button></div>
            </div>
          </td>
          <th ng mat-header-cell *matHeaderCellDef></th>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <ng-container *ngIf="trainingPlans">
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="element-row cp" (click)="showCourseDetail(row)"></tr>
        </ng-container>
        <ng-container *ngIf="!trainingPlans">
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="element-row"></tr>
        </ng-container>
      </table>
      <mat-paginator *ngIf="courseProgramsTable.data.length > 0" #coursesPaginator [pageSizeOptions]="[5, 10, 25]" showFirstLastButtons></mat-paginator>
      <div class="message-box warning" *ngIf="courseProgramsTable.data.length == 0">
        <mat-label translate>COMMONS.NO_ELEMENTFOUND</mat-label>
      </div>
    </div>
  </mat-card>

</div>

<div *ngIf="isLoading">
    <tb-loading></tb-loading>
</div>
